<template>
  <sidebar :title="`Top Up ${selectedSubRetailerUser?.name || ''} Balance`" :show="showSubRetailerUserBalanceSidebar"
    @on-close="close" size="sm">
    <template v-slot:body>
      <div class="row">
        <div class="col">
          <div class="form-group">
            <label>Amount</label>
            <div class="mb-3">
              <input type="number" class="form-control" :disabled="subRetailerSubmitting" v-model="amount"
                @focus="$event.target.select()" min="0" @keydown="preventNegative($event)" />
            </div>
          </div>
        </div>
      </div>

      <div class="text-center">
        <button type="button" class="btn bg-info bg-violet text-white w-100 mt-4 mb-0" @click="submitSubRetailer">
          <i class="fa-solid fa-spinner fa-spin-pulse mx-1" v-if="subRetailerSubmitting"></i>
          Submit
        </button>
      </div>
    </template>
  </sidebar>
  <GlobalModal :show="modal.show" :title="modal.title" :message="modal.message" :type="modal.type"
    @confirm="modal.onConfirm" @cancel="modal.onCancel" @close="modal.show = false" />
</template>

<script>
import sidebar from "../../../../../components/sidebar.vue";
import { mapActions, mapMutations, mapState } from "vuex";
import GlobalModal from "@/components/GlobalModal.vue";

export default {
  components: {
    sidebar,
    GlobalModal
  },
  data() {
    return {
      amount: 0,
      modal: { show: false, type: 'success', title: '', message: '' }
    };
  },
  computed: {
    ...mapState({
      showSubRetailerUserBalanceSidebar: (state) =>
        state.retailerController.showSubRetailerUserBalanceSidebar,
      subRetailerSubmitting: (state) =>
        state.retailerController.subRetailerSubmitting,
      selectedSubRetailer: (state) =>
        state.retailerController.selectedSubRetailer,
      selectedSubRetailerUser: (state) =>
        state.retailerController.selectedSubRetailerUser,
      subRetailers: (state) => state.retailerController.subRetailers,
      selectedRetailer: (state) => state.retailerController.selectedRetailer,
      retailers: (state) => state.retailerController.retailers,
    }),
  },
  methods: {
    ...mapActions({
      getRetailers: "retailerController/GetRetailers",
      getSubRetailers: "retailerController/GetSubRetailers",
      getSubRetailersUser: "retailerController/GetSubRetailerUsers",
      updateSubRetailerUserBalance:
        "retailerController/UpdateSubRetailerUserBalance",
    }),
    ...mapMutations({
      setShowSubRetailerUserBalanceSidebar:
        "retailerController/SET_ShowSubRetailerUserBalanceSidebar",
      selectSubRetailer: "retailerController/SELECT_SubRetailer",
      selectSubRetailerUser: "retailerController/SELECT_SubRetailerUser",
      setSelectedRetailer: "retailerController/SET_SelectedRetailer",
    }),
    close() {
      this.selectSubRetailerUser(null);
      this.setShowSubRetailerUserBalanceSidebar(false);
      this.amount = 0;
    },
    async submitSubRetailer() {
      var result = await this.updateSubRetailerUserBalance(this.amount)
        .catch((error) => {

          const errorMsg =
            error.data.Message ||
            "An unexpected error occurred.";

          this.showModal(
            'error',
            `${errorMsg}`,
          );
        });

      if (result) {

        this.showModal(
          'success',
          `Sub Retailer User ${this.selectedSubRetailerUser.name} successfully loaded.`,
        );
        await this.getSubRetailersUser();
        await this.getSubRetailers();
        await this.getRetailers();

        const updated = this.retailers.find(
          (r) => r.retailerID === this.selectedRetailer.retailerID
        );

        if (updated) {
          this.setSelectedRetailer({ ...updated }); // ← now using the correct data
        }

        this.close();
      }
    },
    preventNegative(event) {
      if (event.key === "-" || event.key === "e") {
        event.preventDefault();
      }
    },
    showModal(type, title, message) {
      return new Promise((resolve) => {
        this.modal = {
          show: true,
          type,
          title,
          message,
          onConfirm: () => {
            this.modal.show = false;
            resolve(true);
          },
          onCancel: () => {
            this.modal.show = false;
            resolve(false);
          },
        };
      });
    }
  },
};
</script>

<style></style>
